import React from 'react';
import ClayTable from "@clayui/table";
import { CGE } from '../../../../common/components/CGE';
import arTitles from '../../../../common/services/mock/title.json';
import { decode_utf8, getPageLayoutType } from '../../../../common/utils/utilsFunc';
import { LiferayService } from '../../../../common/services/liferay';

const TableLastTickets = ({ props }) => {
    let propsTable = {
        'auxArray': props.newArrayExcel,
        'arTitles': arTitles,
        'disabled': props.errorShow ? true : false,
    }

    var panelActions = <>
        <CGE.InlineRow>
            <CGE.InlineCol>
                <CGE.ButtonExcel
                    props={propsTable}
                />
            </CGE.InlineCol>
        </CGE.InlineRow>
    </>

    function getTicket(index) {
        LiferayService.getResponseDoc(props.base_url_api,
            props.state.idCtaCto, props.url_ws_empresa, props.codigo_empresa,
            props.newArrayExcel[index]["DocumentoImpresion"]).then((response) => {
                if (response.code === 0) {
                    window.open(response.boleta, "_blank")
                } else {
                    window.open(response.message, "_blank")
                }
            })
    }

    return (
        <CGE.Panel
            title={decode_utf8(props.titulo_last_tickets)}
            description={getPageLayoutType() ? decode_utf8(props.descripcione_last_tickets) : `Total de Registros: 1 - ${props.qnt_list_boletas} de ${props.qnt_list_boletas}`}
            topContent={getPageLayoutType() && panelActions}
        >
            <div className="container-table">
                <ClayTable
                    class="table table-striped table-autofit show-quick-actions-on-hover table-list table-nowrap tbody-valign-middle thead-valign-middle table-valign-middle"
                    id="table-to-xls"
                >
                    <ClayTable.Head>
                        <ClayTable.Row>
                            {props.newArrTitle?.map((title) => {
                                return (
                                    <ClayTable.Cell
                                        className="clientCell font-weight-bold"
                                        headingCell
                                    >
                                        {title}
                                    </ClayTable.Cell>
                                );
                            })}
                        </ClayTable.Row>
                    </ClayTable.Head>
                    <ClayTable.Body>
                        {!props.errorShow && props.newArray?.map((obj) => {
                            return (
                                <ClayTable.Row className="tableRow">
                                    {Object.keys(obj).map((index) => {
                                        return (
                                            <ClayTable.Cell
                                                className=" txt-with-link clientCell-td table-cell-minw-150 table-cell-expand text-truncate"
                                                title={obj[index]?.length > 23 ? obj[index] : ""}
                                            >
                                                {index === "DocumentoImpresion" ? (

                                                    <div className="d-flex align-items-center justify-content-between">
                                                        {getPageLayoutType() &&
                                                            <a
                                                                onClick={() => getTicket(props.newArray?.indexOf(obj))}
                                                            >
                                                                <CGE.Icon style={{ fontSize: "40px" }} name="document" />
                                                            </a>}
                                                        <CGE.Button
                                                            onClick={() => props.getDetailTicket([obj["DocumentoImpresion"], obj["FechaEmision"]])}
                                                            type="primary"
                                                            label="Ver Detalle"
                                                            size="sm"
                                                            blank={true}
                                                        >
                                                        </CGE.Button>
                                                    </div>
                                                ) :
                                                    (
                                                        obj[index]
                                                    )}
                                            </ClayTable.Cell>
                                        );
                                    })}
                                </ClayTable.Row>
                            );
                        })}
                    </ClayTable.Body>
                </ClayTable>

            </div>
            {getPageLayoutType() && <div>
                <CGE.Button
                    className="mx-auto"
                    onClick={() => props.handleButtonBackAttachedComponent()}
                    type="primary"
                    label="Volver"
                />
            </div>}
        </CGE.Panel>
    )
}

export default TableLastTickets